import { render, staticRenderFns } from "./PurchWarranty.vue?vue&type=template&id=99dfdc64&scoped=true"
import script from "./PurchWarranty.vue?vue&type=script&lang=js"
export * from "./PurchWarranty.vue?vue&type=script&lang=js"
import style0 from "./PurchWarranty.vue?vue&type=style&index=0&id=99dfdc64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dfdc64",
  null
  
)

export default component.exports